document.documentElement.classList.remove('no-js');

const siteHeader = document.querySelector('[data-site-header]');
const cartDrawer = document.querySelector('[data-cart-drawer]');
const cartDrawerItems = cartDrawer?.querySelector('[data-cart-drawer-items]');
const cartDrawerFooter = cartDrawer?.querySelector('[data-cart-drawer-footer]');
const cartDrawerStatus = cartDrawer?.querySelector('[data-cart-drawer-status]');

const syncHeader = () => {
  if (!siteHeader) return;
  siteHeader.classList.toggle('scrolled', window.scrollY > 60);
};
syncHeader();
window.addEventListener('scroll', syncHeader, { passive: true });

document.addEventListener('click', event => {
  const cartOpen = event.target.closest('[data-cart-open]');
  if (cartOpen) {
    event.preventDefault();
    openCartDrawer();
  }

  const cartClose = event.target.closest('[data-cart-close]');
  if (cartClose) {
    event.preventDefault();
    closeCartDrawer();
  }

  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-primary-menu]');
    const open = menu && !menu.classList.contains('open');
    if (menu) menu.classList.toggle('open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  const menuLink = event.target.closest('[data-primary-menu] a');
  if (menuLink) {
    const menu = menuLink.closest('[data-primary-menu]');
    const toggleButton = document.querySelector('[data-menu-toggle]');
    if (menu) menu.classList.remove('open');
    if (toggleButton) toggleButton.setAttribute('aria-expanded', 'false');
  }

  const minus = event.target.closest('[data-qty-minus]');
  const plus = event.target.closest('[data-qty-plus]');
  if (minus || plus) {
    const input = event.target.closest('.quantity-row, .pdp-qty')?.querySelector('input');
    if (!input) return;
    const current = parseInt(input.value || '1', 10);
    input.value = String(Math.max(1, current + (plus ? 1 : -1)));
  }

  const cartMinus = event.target.closest('[data-cart-qty-minus]');
  const cartPlus = event.target.closest('[data-cart-qty-plus]');
  if (cartMinus || cartPlus) {
    const line = event.target.closest('[data-cart-line]');
    const input = line?.querySelector('.cart-drawer-qty input');
    if (!input) return;
    const current = parseInt(input.value || '1', 10);
    const nextQuantity = Math.max(0, current + (cartPlus ? 1 : -1));
    input.value = String(nextQuantity);
    if (line?.dataset.cartLineKey) {
      changeCartLine(line.dataset.cartLineKey, nextQuantity, line);
    }
  }

  const cartRemove = event.target.closest('[data-cart-remove]');
  if (cartRemove) {
    event.preventDefault();
    const line = event.target.closest('[data-cart-line]');
    if (line?.dataset.cartLineKey) {
      changeCartLine(line.dataset.cartLineKey, 0, line);
    }
  }

  const thumb = event.target.closest('[data-pdp-thumb]');
  if (thumb) {
    const gallery = thumb.closest('[data-pdp-gallery]');
    const main = gallery?.querySelector('[data-pdp-main-image]');
    if (!main) return;
    main.src = thumb.dataset.full;
    main.alt = thumb.dataset.alt || main.alt;
    gallery.querySelectorAll('[data-pdp-thumb]').forEach(button => button.classList.toggle('active', button === thumb));
  }

  const galleryArrow = event.target.closest('[data-pdp-prev], [data-pdp-next]');
  if (galleryArrow) {
    const gallery = galleryArrow.closest('[data-pdp-gallery]');
    const thumbs = Array.from(gallery?.querySelectorAll('[data-pdp-thumb]') || []);
    if (!thumbs.length) return;
    const current = Math.max(0, thumbs.findIndex(button => button.classList.contains('active')));
    const direction = galleryArrow.matches('[data-pdp-next]') ? 1 : -1;
    const next = (current + direction + thumbs.length) % thumbs.length;
    thumbs[next].click();
    thumbs[next].scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
  }

  const carouselArrow = event.target.closest('[data-carousel-prev], [data-carousel-next]');
  if (carouselArrow) {
    const carousel = carouselArrow.closest('.cat-carousel');
    const track = carousel?.querySelector('[data-carousel-track]');
    if (!track) return;
    const direction = carouselArrow.matches('[data-carousel-next]') ? 1 : -1;
    const card = track.querySelector('.product-card');
    const distance = card ? card.getBoundingClientRect().width + 30 : track.clientWidth * 0.8;
    track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    window.setTimeout(() => syncCarouselArrows(carousel), 350);
  }

  const optionButton = event.target.closest('[data-option-value]');
  if (optionButton) {
    const form = optionButton.closest('[data-product-form]');
    if (!form) return;
    const position = optionButton.dataset.optionPosition;
    const selectedLabel = form.querySelector(`[data-selected-option="${position}"]`);
    if (selectedLabel) selectedLabel.textContent = optionButton.dataset.optionValue;
    form.querySelectorAll(`[data-option-position="${position}"]`).forEach(button => {
      const active = button === optionButton;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    syncProductVariant(form);
  }
});

document.addEventListener('submit', event => {
  const productForm = event.target.closest('[data-product-form]');
  const variantSelect = productForm?.querySelector('[data-variant-select]');
  if (productForm?.dataset.requiresVariantChoice === 'true' && !variantSelect?.value) {
    event.preventDefault();
    lockProductPurchase(productForm, 'Select an option');
    productForm.querySelector('[data-product-options]')?.scrollIntoView({ block: 'center' });
    return;
  }

  const form = event.target.closest('form[action*="/cart/add"]');
  const addButton = event.submitter?.closest?.('[data-add-button]');
  if (!form || !addButton) return;

  event.preventDefault();
  addButton.disabled = true;
  addButton.dataset.originalText = addButton.dataset.originalText || addButton.textContent;
  addButton.textContent = 'Adding...';

  fetch(form.action, {
    method: 'POST',
    body: new FormData(form),
    headers: { Accept: 'application/json' }
  })
    .then(response => {
      if (!response.ok) throw new Error('Unable to add item');
      return response.json();
    })
    .then(() => openCartDrawer(true))
    .catch(() => {
      window.location.href = '/cart';
    })
    .finally(() => {
      addButton.disabled = false;
      addButton.textContent = addButton.dataset.originalText || 'Add to Cart';
    });
});

let cartReturnFocus = null;

document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && cartDrawer?.classList.contains('is-open')) {
    closeCartDrawer();
    return;
  }

  const menu = document.querySelector('[data-primary-menu]');
  if (event.key === 'Escape' && menu?.classList.contains('open')) {
    const toggleButton = document.querySelector('[data-menu-toggle]');
    menu.classList.remove('open');
    if (toggleButton) {
      toggleButton.setAttribute('aria-expanded', 'false');
      toggleButton.focus();
    }
    return;
  }

  // Keep Tab inside the cart drawer while it is open. Without this the drawer
  // is an aria-modal dialog that keyboard focus can simply walk out of, landing
  // on the product links hidden behind the overlay.
  if (event.key === 'Tab' && cartDrawer?.classList.contains('is-open')) {
    const focusables = getFocusable(cartDrawer);
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement;

    if (event.shiftKey && (active === first || !cartDrawer.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !cartDrawer.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  }
});

function getFocusable(root) {
  return Array.from(
    root.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )
  ).filter(el => el.offsetParent !== null || el === document.activeElement);
}

document.querySelectorAll('.cat-carousel').forEach(carousel => {
  const track = carousel.querySelector('[data-carousel-track]');
  if (!track) return;
  syncCarouselArrows(carousel);
  track.addEventListener('scroll', () => syncCarouselArrows(carousel), { passive: true });
});

initStatementCarousel();

function openCartDrawer(refresh = true) {
  if (!cartDrawer) {
    window.location.href = '/cart';
    return;
  }
  // Remember where focus came from so it can be handed back on close.
  cartReturnFocus = document.activeElement;
  cartDrawer.hidden = false;
  cartDrawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('cart-drawer-open');
  window.requestAnimationFrame(() => {
    cartDrawer.classList.add('is-open');
    const closeButton = cartDrawer.querySelector('.cart-drawer-close');
    (closeButton || getFocusable(cartDrawer)[0])?.focus();
  });
  if (refresh) renderCartDrawer();
}

function closeCartDrawer() {
  if (!cartDrawer) return;
  // aria-hidden on an element containing the focused node is invalid, so move
  // focus out before the attribute goes back on.
  if (cartDrawer.contains(document.activeElement)) {
    if (cartReturnFocus && document.body.contains(cartReturnFocus)) {
      cartReturnFocus.focus();
    } else {
      document.activeElement.blur();
    }
  }
  cartReturnFocus = null;
  cartDrawer.classList.remove('is-open');
  cartDrawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('cart-drawer-open');
  window.setTimeout(() => {
    if (!cartDrawer.classList.contains('is-open')) cartDrawer.hidden = true;
  }, 260);
}

function renderCartDrawer() {
  if (!cartDrawerItems || !cartDrawerFooter) return;
  // Only announce loading when there is nothing on screen yet. Repainting an
  // already-populated drawer should not flash a status message.
  if (!cartDrawerItems.innerHTML.trim()) setCartStatus('Loading cart...');
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(response => response.json())
    .then(cart => {
      updateCartCount(cart.item_count);
      if (!cart.items.length) {
        cartDrawerItems.innerHTML = '';
        cartDrawerFooter.innerHTML = '';
        setCartStatus('Your cart is empty.');
        return;
      }

      setCartStatus('');
      cartDrawerItems.innerHTML = cart.items.map(renderCartItem).join('');
      cartDrawerFooter.innerHTML = `
        <div class="cart-total-row"><span>Subtotal</span><span data-cart-total>${formatMoney(cart.total_price)}</span></div>
        <div class="cart-total-row"><span>Shipping</span><span>Calculated at checkout</span></div>
        <div class="cart-total-row total"><span>Total</span><strong data-cart-total>${formatMoney(cart.total_price)}</strong></div>
        <a class="cart-checkout-btn" href="/checkout">Checkout</a>
      `;
    })
    .catch(() => setCartStatus('Cart could not load. Please refresh the page.'));
}

function renderCartItem(item) {
  const image = item.featured_image?.url || item.image || '';
  const option = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-drawer-option">${escapeHtml(item.variant_title)}</div>` : '';
  const properties = renderCartProperties(item.properties);
  return `
    <article class="cart-drawer-line" data-cart-line data-cart-line-key="${escapeHtml(item.key)}">
      <a class="cart-drawer-image" href="${escapeHtml(item.url)}">
        ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : ''}
      </a>
      <div class="cart-drawer-info">
        <a class="cart-drawer-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
        ${option}
        ${properties}
        <div class="cart-drawer-qty">
          <button type="button" data-cart-qty-minus aria-label="Decrease quantity">-</button>
          <input type="number" min="0" value="${item.quantity}" aria-label="Quantity for ${escapeHtml(item.product_title)}">
          <button type="button" data-cart-qty-plus aria-label="Increase quantity">+</button>
        </div>
      </div>
      <div class="cart-drawer-right">
        <div class="cart-drawer-price">${formatMoney(item.final_line_price)}</div>
        <a class="cart-drawer-remove" href="/cart/change?id=${encodeURIComponent(item.key)}&quantity=0" data-cart-remove>Remove</a>
      </div>
    </article>
  `;
}

function renderCartProperties(properties) {
  if (!properties || Array.isArray(properties)) return '';
  return Object.entries(properties)
    .filter(([key, value]) => value && key.charAt(0) !== '_')
    .map(([key, value]) => `<div class="cart-drawer-property">${escapeHtml(key)}: ${escapeHtml(String(value))}</div>`)
    .join('');
}

function changeCartLine(id, quantity, line) {
  const inDrawer = !line || Boolean(line.closest('[data-cart-drawer]'));
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ id, quantity })
  })
    .then(response => response.json())
    .then(cart => {
      updateCartCount(cart.item_count);
      if (!inDrawer) {
        refreshCartPage(cart);
      } else if (!cart.items || !cart.items.length) {
        renderCartDrawer();
      } else {
        patchCartLines(cartDrawer, cart);
      }
    })
    .catch(() => {
      if (inDrawer) {
        renderCartDrawer();
      } else {
        window.location.reload();
      }
    });
}

// Repaint the /cart page in place after a quantity change, so line totals and
// the summary follow the stepper without a page reload.
function refreshCartPage(cart) {
  const page = document.querySelector('.cart-page');
  if (!page) return;

  if (!cart.items || !cart.items.length) {
    window.location.reload();
    return;
  }

  patchCartLines(page, cart);
}

// Update the line totals, quantities and summary inside `root` from a cart
// payload, touching only the text that changed.
function patchCartLines(root, cart) {
  if (!root) return;
  const itemsByKey = new Map(cart.items.map(item => [item.key, item]));

  root.querySelectorAll('[data-cart-line]').forEach(node => {
    const item = itemsByKey.get(node.dataset.cartLineKey);
    if (!item) {
      node.remove();
      return;
    }
    const price = node.querySelector('.cart-drawer-price');
    if (price) price.textContent = formatMoney(item.final_line_price);
    const input = node.querySelector('.cart-drawer-qty input');
    if (input && document.activeElement !== input) input.value = String(item.quantity);
  });

  root.querySelectorAll('[data-cart-total]').forEach(node => {
    node.textContent = formatMoney(cart.total_price);
  });
}

function updateCartCount(count) {
  document.querySelectorAll('.cart-count').forEach(item => {
    item.textContent = String(count);
  });
}

function setCartStatus(message) {
  if (!cartDrawerStatus) return;
  cartDrawerStatus.textContent = message;
  cartDrawerStatus.hidden = message === '';
}

function formatMoney(cents) {
  const currency = window.Shopify?.currency?.active || 'USD';
  return (Number(cents || 0) / 100).toLocaleString('en-US', {
    style: 'currency',
    currency
  });
}

function escapeHtml(value) {
  return String(value || '').replace(/[&<>"']/g, character => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  })[character]);
}

function syncCarouselArrows(carousel) {
  const track = carousel.querySelector('[data-carousel-track]');
  const prev = carousel.querySelector('[data-carousel-prev]');
  const next = carousel.querySelector('[data-carousel-next]');
  if (!track || !prev || !next) return;
  prev.classList.toggle('is-hidden', track.scrollLeft <= 8);
  next.classList.toggle('is-hidden', track.scrollLeft + track.clientWidth >= track.scrollWidth - 8);
}

function initStatementCarousel() {
  const carousel = document.querySelector('[data-statement-carousel]');
  if (!carousel || carousel.dataset.carouselReady === 'true') return;

  const images = Array.from(carousel.querySelectorAll(':scope > img'));
  if (!images.length) return;

  carousel.classList.add('statement-carousel');
  carousel.dataset.carouselReady = 'true';
  carousel.dataset.singleSlide = images.length < 2 ? 'true' : 'false';

  const dots = document.createElement('div');
  dots.className = 'statement-dots';
  let activeIndex = 0;
  let timer = null;

  images.forEach((img, index) => {
    const slide = document.createElement('div');
    slide.className = `statement-slide${index === 0 ? ' is-active' : ''}`;
    carousel.insertBefore(slide, img);
    slide.appendChild(img);

    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = `statement-dot${index === 0 ? ' is-active' : ''}`;
    dot.setAttribute('aria-label', `Show image ${index + 1}`);
    dot.addEventListener('click', () => showSlide(index, true));
    dots.appendChild(dot);
  });

  carousel.appendChild(dots);
  const dotButtons = Array.from(dots.querySelectorAll('.statement-dot'));

  function showSlide(nextIndex, manual) {
    if (nextIndex === activeIndex) return;
    const slides = carousel.querySelectorAll('.statement-slide');
    slides[activeIndex].classList.remove('is-active');
    dotButtons[activeIndex].classList.remove('is-active');
    activeIndex = nextIndex;
    slides[activeIndex].classList.add('is-active');
    dotButtons[activeIndex].classList.add('is-active');
    if (manual) restart();
  }

  function start() {
    if (images.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    timer = setInterval(() => showSlide((activeIndex + 1) % images.length, false), 3000);
  }

  function stop() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  function restart() {
    stop();
    start();
  }

  carousel.addEventListener('mouseenter', stop);
  carousel.addEventListener('mouseleave', start);
  carousel.addEventListener('focusin', stop);
  carousel.addEventListener('focusout', start);
  start();
}

function syncProductVariant(form) {
  const variantScript = form.parentElement?.querySelector('[data-product-variants]');
  const variantSelect = form.querySelector('[data-variant-select]');
  if (!variantScript || !variantSelect) return;

  let variants = [];
  try {
    variants = JSON.parse(variantScript.textContent || '[]');
  } catch {
    return;
  }

  const selected = [];
  form.querySelectorAll('[data-selected-option]').forEach(label => {
    const index = Number(label.dataset.selectedOption) - 1;
    selected[index] = label.textContent.trim();
  });

  const optionCount = form.querySelectorAll('[data-selected-option]').length;
  const hasAllSelections = optionCount > 0 && selected.filter(Boolean).length === optionCount;
  if (!hasAllSelections) {
    variantSelect.value = '';
    lockProductPurchase(form, 'Select an option');
    return;
  }

  const variant = variants.find(item => {
    if (!Array.isArray(item.options)) return false;
    return item.options.every((option, index) => selected[index] === option);
  });
  if (!variant) {
    variantSelect.value = '';
    lockProductPurchase(form, 'Unavailable');
    return;
  }

  variantSelect.value = String(variant.id);
  const selectedOption = variantSelect.querySelector(`option[value="${variant.id}"]`);
  const available = selectedOption?.dataset.available !== 'false' && variant.available !== false;
  const addButton = form.querySelector('[data-add-button]');
  if (addButton) {
    addButton.disabled = !available;
    addButton.textContent = available ? 'Add to Cart' : 'Sold Out';
  }
  const dynamicCheckout = form.querySelector('[data-dynamic-checkout]');
  if (dynamicCheckout) {
    dynamicCheckout.classList.toggle('is-disabled', !available);
    dynamicCheckout.setAttribute('aria-disabled', available ? 'false' : 'true');
  }

  const priceTarget = (form.closest('.pdp-info') || form.parentElement)?.querySelector('[data-product-price]');
  const priceValue = selectedOption?.dataset.price || '';
  if (priceTarget && priceValue && priceTarget.dataset.staticPrice !== 'true') {
    const unit = selectedOption?.dataset.unit || priceTarget.dataset.priceUnit || '';
    priceTarget.innerHTML = `${escapeHtml(priceValue)}${unit ? ` <span class="pdp-price-unit">/ ${escapeHtml(unit)}</span>` : ''}`;
  }

  const mediaId = selectedOption?.dataset.mediaId || variant.featured_media?.id || '';
  if (mediaId) {
    const thumb = document.querySelector(`[data-pdp-thumb][data-media-id="${mediaId}"]`);
    if (thumb) thumb.click();
  }
}

function lockProductPurchase(form, label) {
  const addButton = form.querySelector('[data-add-button]');
  if (addButton) {
    addButton.disabled = true;
    addButton.textContent = label;
  }
  const dynamicCheckout = form.querySelector('[data-dynamic-checkout]');
  if (dynamicCheckout) {
    dynamicCheckout.classList.add('is-disabled');
    dynamicCheckout.setAttribute('aria-disabled', 'true');
  }
}

// A quantity typed straight into the field (or nudged with the arrow keys)
// should reach the cart the same way the +/- buttons do.
document.addEventListener('change', event => {
  const input = event.target.closest('.cart-drawer-qty input');
  if (!input) return;
  const line = input.closest('[data-cart-line]');
  if (!line?.dataset.cartLineKey) return;
  const quantity = Math.max(0, parseInt(input.value || '0', 10) || 0);
  input.value = String(quantity);
  changeCartLine(line.dataset.cartLineKey, quantity, line);
});
